import { useEffect, useState } from 'react';
import { asyncGetOrbitCaseById } from '../../../../services/orbit.service';
import { ToastSwal } from '../../../components/general/toastSwals/toastSwal';
import {
    mapOrbitCaseToRadicationValues,
    OrbitRadicationFormValues,
} from '../utils/mapOrbitCaseToRadicationValues';

export const useOrbitCaseDetailLoader = (caseId: string | undefined) => {
    const [loadingCase, setLoadingCase] = useState(Boolean(caseId));
    const [caseValues, setCaseValues] =
        useState<OrbitRadicationFormValues | null>(null);

    useEffect(() => {
        if (!caseId) {
            setCaseValues(null);
            setLoadingCase(false);
            return;
        }

        let cancelled = false;
        setLoadingCase(true);
        setCaseValues(null);

        asyncGetOrbitCaseById(caseId)
            .then((orbitCase) => {
                if (cancelled) return;

                if (!orbitCase) {
                    ToastSwal.fire({
                        icon: 'error',
                        text: 'No se encontró el caso en Orbit.',
                        position: 'center-end',
                    });
                    return;
                }

                setCaseValues(mapOrbitCaseToRadicationValues(orbitCase));
            })
            .finally(() => {
                if (!cancelled) setLoadingCase(false);
            });

        return () => {
            cancelled = true;
        };
    }, [caseId]);

    return { loadingCase, caseValues };
};
